import { render, staticRenderFns } from "./Content_references.vue?vue&type=template&id=2ff491dd&scoped=true"
import script from "./Content_references.vue?vue&type=script&lang=js"
export * from "./Content_references.vue?vue&type=script&lang=js"
import style0 from "./Content_references.vue?vue&type=style&index=0&id=2ff491dd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff491dd",
  null
  
)

export default component.exports